import Blue from "~/core";

new Blue({
	name: 'FAQ',
	selector: ".faq",
	setup(faq) {
		let items = faq.querySelectorAll('.faq__item');

		items.forEach(item => {
			let title = item.querySelector('.faq__title');
			let close = item.querySelector('.faq__close');
			let content = item.querySelector('.faq__content');
			let inner = item.querySelector('.faq__content-inner');
			let start, end;

			title.setAttribute("tabindex", 0);

			this.$addEvents([title, close], 'click.stop enter.prevent', () => {
				start = content.offsetHeight;
				if (item.hasAttribute('data-active')) {
					item.removeAttribute('data-active', true);
					this.$scrollLock.unlock(inner);
				}
				else {
					item.setAttribute('data-active', true);
					if (!this.$screen.md.matches) {
						this.$scrollLock.lock(inner);
					}
				}
				end = content.offsetHeight;

				content.animate([
					{height: `${start}px`},
					{height: `${end}px`}
				], {
					duration: 350,
					easing: 'ease'
				})

				if (item.hasAttribute('data-active')) {
					setTimeout(() => {
						close.focus();
					}, 400)
				}
			})
		})
	}
});